const messages = {
  'en-US': enUS_Translations,
  'es-ES': esES_Translations,
}



const i18n = new VueI18n({
  locale: 'en-US', // set locale
  fallbackLocale: 'en-US', // set fallback locale
  messages, // set locale messages
  // If you need to specify other options, you can set other options
  // ...
})

Vue.use(i18n)
